import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import I18N from '../../utils/I18nMessageProvider'
import GlobalVars, { KEYS } from '../../utils/GlobalVars'
import TextField from '@material-ui/core/TextField'

import { GEOCOUNTRY_URL } from '../../constants/Constants'
import Autosuggest from 'react-autosuggest'
import s from '../TripAdvisor/SearchComponent.css'

const DEFAULT_LANG = 'enEN'
const DIALOG_ID = 'DIALOG'
const DIALOG_PARENT_ID = 'DIALOG_PARENT'

const classes = {
  root: {
    flexGrow: 1,
    height: 250,
  },
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
  },
  chip: {},
  inputRoot: {
    flexWrap: 'wrap',
  },
  divider: {},
}

class CountryChooser extends BasicViewComponent {

  constructor (props) {
    super(props)
    this.changeTimer = null
    this.filtered = {}
    this.latestSearchText = ''
    this.state = {
      countries: [],
      open: false,
      selectedCountry: null,
      dataSource: [],
      suggestions: [],
      value: ''
    }
  }

  componentDidMount () {
    this.fetchAvailableCountries()
  }

  componentDidUpdate () {
    // set position of dialog correctly
    setTimeout(() => {
      const dom = document.getElementById(DIALOG_ID)
      if (dom && dom.parentElement && dom.parentElement.parentElement && dom.parentElement.parentElement.parentElement) {
        const elem = dom.parentElement.parentElement.parentElement.style
        elem.position = 'fixed'
        elem.top = '0'
        elem.left = '50%'
        elem.transform = 'translate(-50%, 10px)'
      }
    })
  }

  fetchAvailableCountries () {
    const lang = GlobalVars.get(KEYS.LOCALE).substring(0, 2) || DEFAULT_LANG
    // console.log('lang', lang)
    fetch(`${GEOCOUNTRY_URL}?lang=${lang}`).then(
      (response) => {
        if (response.status === 200) {
          response.json().then(
            (json) => {
              if (json && json.success && json.data) {
                const countriesSorted = json.data.sort((c1, c2) => c1.name < c2.name ? -1 : 1)
                countriesSorted.forEach(country => {
                  country.dataValue = {
                    country: country.country,
                    name: country.name
                  }
                })

                this.setState({
                  countries: countriesSorted
                })
              }
              else if (json.error) {
                console.error('couldn\'t load country list', json.error)
              }
              else {
                console.error('couldn\'t load country list (no error message given)')
              }
            },
            (error) => {
              console.error('couldn\'t load country list', error)
            }
          )
        }
      },
      (error) => {
        console.error('couldn\'t load country list', error)
      }
    )
  }

  filter = (searchText, key, object) => {
    return true
    // const prefiltered = AutoComplete.caseInsensitiveFilter(searchText, key, object)
    // if (!prefiltered) {
    //   return false
    // }
    //
    // if (!this.filtered[searchText] || this.filtered[searchText].name > object.name) {
    //   this.filtered[searchText] = object
    // }
    // this.latestSearchText = searchText
    // return true
  }

  handleClose = () => {
    this.setState({
      open: false
    })
  }

  handleOpen = () => {
    this.setState({
      open: true
    })
  }

  onCountryChosen = (event, {suggestion}) => {
    const textOrObject = suggestion
    let selectedCountry = null
    if (typeof textOrObject === 'string') {
      selectedCountry = this.filtered[this.latestSearchText]
    }
    else {
      selectedCountry = textOrObject
    }
    this.setState({
      selectedCountry
    })
    this.props.setSelectedCountry(selectedCountry.country)
  }

  renderInput (inputProps) {
    const {InputProps, classes, ref, ...other} = inputProps

    return (
      <TextField
        InputProps={{
          inputRef: ref,
          classes: {
            root: classes.inputRoot,
          },
          ...InputProps,
        }}
        {...other}
      />
    )
  }

  clearSuggestions = () => {
    console.warn('clear required')
    // this.setState({
    //   sugestions: []
    // })
  }

  /**
   * @param value - the current value of the text input
   * @param reason - one of 'input-changed', 'input-focused', 'escape-pressed', 'suggestions-revealed', 'suggestion-selected'
   */
  onFetchRequired = ({value, reason}) => {

    const suggestions = this.state.countries.filter(country => {
      return country.name.toLowerCase().indexOf(value.toLowerCase()) >= 0
    })
    this.setState({suggestions: suggestions})

    // // clear existing request timer
    // if (this.searchIconTimeout) {
    //   window.clearTimeout(this.searchIconTimeout)
    // }
    //
    // const searchStringTrimmed = value.trim()
    //
    // if (searchStringTrimmed.length < 3) {
    //   return
    // }
    //
    // this.searchIconTimeout = window.setTimeout(() => {
    //   PoiRequests.searchQuery(searchStringTrimmed, this.props.mapPosition, NUMBER_OF_ITEMS_TO_REQUEST).then(
    //     (result) => {
    //       this.replaceDataSource(result)
    //     },
    //     (error) => {
    //       // better clear all data results than having a search string not matching the results
    //       this.setState({
    //         suggestions: []
    //       })
    //       console.log(error)
    //       this.props.onError(error.message)
    //     }
    //   )
    // }, 300)
  }

  getSuggestionValue (country) {
    return country.name
  }

  onBlur = () => {
    if (window.KesiTools) {
      window.KesiTools.notifyTextfieldBlurred()
    }
  }

  onTextChange = (event, {newValue, method}) => {
    const suggestions = this.state.countries.filter(country => {
      return country.name.indexOf(newValue) >= 0
    })

    this.setState({
      suggestions: suggestions,
      value: newValue
    })
  }

  renderSuggestion = (suggestion) => {
    return (
      <div className={s.searchItem}>
        <div className={s.header}>{suggestion.name}</div>
        <div className={s.extraInfo}>{suggestion.countryName}</div>
      </div>
    )
  }

  renderAutoComplete () {

    const {value, suggestions} = this.state
    const inputProps = {
      placeholder: I18N.get('tripproxy.search.hint'),
      value: value,
      onChange: this.onTextChange,
      onBlur: this.onBlur
    }

    return (
      <div>
        <div>
          <div style={{
            fontSize: 16,
            padding: '20px 10px',
            fontWeight: 400
          }}>{I18N.get('tripproxy.countries.chooseCountry')}</div>
        </div>

        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onFetchRequired}
          onSuggestionsClearRequested={this.clearSuggestions}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          onSuggestionSelected={this.onCountryChosen}
          inputProps={inputProps}
        />
        <Button
          style={{margin: 7, backgroundColor: 'transparent', fontSize: 12, position: 'absolute', right: 0}}
          onClick={this.handleClose}
        >
          {I18N.get('tripproxy.countries.searchEmbassies')}
        </Button>
      </div>


      // <AutoComplete
      //   hintText={this.state.selectedCountry ? this.state.selectedCountry.name : ''}
      //   dataSource={this.state.countries}
      //   dataSourceConfig={{text: 'name', value: 'dataValue'}}
      //   filter={this.filter}
      //   onNewRequest={this.onCountryChosen}
      //   maxSearchResults={8}
      //   listStyle={{maxHeight: '40vh', overflowY: 'scroll'}}
      //   fullWidth
      // />
    )
  }

  renderButton () {
    const style = {
      backgroundColor: '#fff'
    }
    return (
      <div
        style={{backgroundColor: '#fff'}}
      >
        <Button onClick={this.handleOpen}
                variant="contained"
        >
          {this.state.selectedCountry ? this.state.selectedCountry.name : I18N.get('tripproxy.countries.chooseCountry')}
        </Button>
      </div>
    )
  }

  renderDialog () {
    let dialogHeight = this.state.value.length > 0
      ? 230 + ((this.state.suggestions.length - 1) * 50)    // one fits in without height change, it overlapts the button
      : 230
    return (
      <Dialog
        id={DIALOG_PARENT_ID}
        title={I18N.get('tripproxy.countries.chooseCountry')}
        modal={false}
        open={this.state.open}
        onClose={this.handleClose}
        autoScrollBodyContent={true}
        style={{alignItems: 'unset', maxHeight: dialogHeight}}
      >
        <div id={DIALOG_ID}>
          {this.renderAutoComplete()}
        </div>
      </Dialog>
    )
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    return (
      <div>
        {this.renderButton()}
        {this.renderDialog()}
      </div>
    )
  }

}

CountryChooser.TYPE = 'countryChooser'

CountryChooser.propTypes = {
  config: PropTypes.object.isRequired,
  setSelectedCountry: PropTypes.func
}

export default CountryChooser



// WEBPACK FOOTER //
// ./src/components/ViewComponents/CountryChooser.js